import { EmployeeAreaRoutes } from '@backoffice-frontend/employee-api'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { UsersIcon } from '@moia-dev/pace-icons'
import { useTranslation } from 'react-i18next'
import { EmployeeAreaDataTestIds } from './EmployeeAreaDataTestIds'

export const EmployeeAreaNavigation = ({
  onClick,
  open,
}: AreaNavigationProps) => {
  const { t } = useTranslation()
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={t('employee_navigation_label')}
      to={EmployeeAreaRoutes.route}
      Icon={UsersIcon}
      dataTestId={EmployeeAreaDataTestIds.Navigation}
    />
  )
}
